import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../lib/constants";

export const FAQSection = ({ heading = "Frequently asked questions.", limit }) => {
  const items = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section className="py-24 sm:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">Questions · Answered</div>
          <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] tracking-tight">
            {heading.split(' ').map((w, i) => i === heading.split(' ').length - 1 ? <em key={i} className="text-brand">{w}</em> : <span key={i}>{w} </span>)}
          </h2>
          <p className="mt-6 text-ink-muted leading-relaxed max-w-sm">
            Still unsure? Email us at <a href="mailto:info@districtwellnesscenter.com" className="link-underline text-ink">info@districtwellnesscenter.com</a> —
            a real person responds.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full divide-y divide-black/10 border-y border-black/10">
            {items.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-0" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-6 text-left font-serif text-xl sm:text-2xl hover:text-brand hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base text-ink-muted leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
